function getCodeParam() {
    let params = new URLSearchParams(window.location.search);
    let code = params.get('c');

    return code ? { code: code } : {};
}

export default {

    getClient: function(clientId) {
        return axios.get('/api/clients/' + clientId, {
            params: getCodeParam()
        }).catch(function(error) {
            throw new Error("Client Load Failed, ") + error;
        });
    },

    getClientWithSubscription: function(clientId) {
        return axios.get('/api/clients/' + clientId + '/subscription').catch(function(error) {
            throw new Error("Client Load Failed, ") + error;
        });
    },

    getClientProfileByEmail: function(clientId, email) {
        return axios.get('/api/clients/' + clientId + '/profile/' + email, {
            params: getCodeParam()
        });
    },
}
